import React from "react";
import { Drawer, Box, Typography, IconButton, Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DynamicFilter from "containers/DynamicFilter";

const MobileFilterDrawer = ({
  open,
  onClose,
  filteredCategories,
  selectedCategory,
  selectCategory,
  query,
  navigate,
  isMobileOrTab,
}) => {
  if (!isMobileOrTab) return null;

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: { xs: "100%", sm: "420px", md: "420px" },
          p: 3,
        },
      }}
    >
      {/* HEADER */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
          borderBottom: "1px solid rgba(0,0,0,0.12)",
          pb: 2,
        }}
      >
        <Typography sx={{ fontSize: "1.3rem", fontWeight: 700 }}>
          Filter
        </Typography>

        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>

      {/* FILTER LIST */}
      <DynamicFilter
        filterCategory={[
          {
            title: "Categories",
            type: filteredCategories.type,
            items: filteredCategories.categories || [],
            selectedItem: selectedCategory,
            handleSelect: (category) => {
              selectCategory(category);
              onClose();

              if (!query?.category || query.category !== category) {
                navigate(`/products`);
              }
            },
          },
        ]}
      />

      {/* FOOTER BUTTONS */}
      <Box
        sx={{
          position: "sticky",
          bottom: 0,
          backgroundColor: "#fff",
          pt: 2,
          pb: 2,
          borderTop: "1px solid rgba(0,0,0,0.12)",
          display: "flex",
          gap: 2,
        }}
      >
        <Button
          fullWidth
          variant="outlined"
          sx={{
            textTransform: "none",
            borderRadius: "10px",
          }}
          onClick={() => {
            selectCategory(null);
            onClose();
          }}
        >
          Clear
        </Button>

        <Button
          fullWidth
          variant="contained"
          sx={{
            textTransform: "none",
            borderRadius: "10px",
          }}
          onClick={onClose}
        >
          Show results
        </Button>
      </Box>
    </Drawer>
  );
};

export default MobileFilterDrawer;
